import { usePartnerCompleteProofreadEventApi } from 'api/partner/proofread_event';
import { FilesInput, StringField } from 'components/shared/form/input';
import Modal, { ModalSet } from 'components/shared/modal';
import ThemedButton from 'components/shared/themed_button';
import { GlobalStateContext } from 'contexts/global_state_context';
import { MAX_BULK_ATTACHMENT_EVENT_COUNT, ProofreadEventForm } from 'entities/proofread_event';
import { useForm } from 'rac';
import React, { useContext } from 'react';
import { useEffectSkipFirst } from 'utils/hooks';

type FixDateEventFormDialogProps = {
  modalSet: ModalSet<number[]>;
  planId: number;
  onComplete: () => void;
};
export const FixDateEventFormDialog: React.FC<FixDateEventFormDialogProps> = (props) => {
  const globalState = useContext(GlobalStateContext);

  // 選択機器数が上限を超える場合は添付を不可にする
  const selectedCount = Array.isArray(props.modalSet.item) ? props.modalSet.item.length : 0;
  const attachmentDisabled = selectedCount > MAX_BULK_ATTACHMENT_EVENT_COUNT;

  const patchForm = useForm<ProofreadEventForm>({
    proofreadPlanId: props.planId,
    eventIds: props.modalSet.item,
  });
  const patchApi = usePartnerCompleteProofreadEventApi(patchForm);

  const handleSubmit = () => {
    globalState.confirm('校正結果を登録します。よろしいですか？', (e) => {
      if (e === 'ok') {
        patchApi.execute();
      }
    });
  };

  useEffectSkipFirst(() => {
    if (!props.modalSet.modalState.open) return;
    patchForm.resetForm();
  }, [props.modalSet.modalState.open]);

  useEffectSkipFirst(() => {
    if (!patchApi.isSuccess()) return;
    props.onComplete();
  }, [patchApi.loading]);

  return (
    <Modal
      title="校正完了"
      modalId="attach-event-modal"
      modalState={props.modalSet.modalState}
      size="sm"
      footer={
        <>
          <ThemedButton color="secondary" onClick={() => props.modalSet.closeModal()}>
            閉じる
          </ThemedButton>
          <ThemedButton color="primary" onClick={handleSubmit}>
            完了
          </ThemedButton>
        </>
      }
    >
      <StringField label="結果メモ" form={patchForm} attr="noteOnDealerResult" multiline />

      <label>添付ファイル</label>
      {attachmentDisabled ? (
        // FilesInput は disabled prop を持たず、マウント時に attachmentsAttributes を書き込む
        // 副作用があるため、上限超過時はダミー表示に置き換える
        <>
          <div
            style={{
              marginTop: 4,
              padding: '10px 12px',
              border: '1px dashed #ccc',
              borderRadius: 4,
              color: '#9e9e9e',
              backgroundColor: '#f5f5f5',
              cursor: 'not-allowed',
              userSelect: 'none',
            }}
          >
            ファイルを添付できません
          </div>
          <p style={{ color: 'red', fontSize: 12, margin: '4px 0 0' }}>
            一括でファイル添付できるのは{MAX_BULK_ATTACHMENT_EVENT_COUNT}機器までです
          </p>
        </>
      ) : (
        <FilesInput form={patchForm} attr="attachmentsAttributes" />
      )}
    </Modal>
  );
};

export default FixDateEventFormDialog;
